module.exports = __webpack_public_path__ + "img/trie.8633dfda.svg";